import filterQuestions from './filterQuestions'
import formatQuestionnairesToReport from './formatQuestionnairesToReport'
import statusColor from './statusColor'
import statusLabel from './statusLabel'

const questionnaires = {
  filterQuestions,
  formatQuestionnairesToReport,
  statusColor,
  statusLabel,
}

export default questionnaires
